import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";

export const NAV = [
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/fees", label: "Fees" },
  { to: "/faq", label: "FAQ" },
  { to: "/book", label: "Book/Contact" },
];

const navClass = ({ isActive }) =>
  `text-[15px] transition-colors duration-300 hover:text-[#6F5B9E] ${isActive ? "text-[#6F5B9E]" : "text-[#22304A]"}`;

const Logo = () => (
  <Link to="/" data-testid="header-logo-link" aria-label="Violet Psychotherapy — home" className="shrink-0 py-1">
    <img src="/logo.webp" alt="Violet Psychotherapy" width="180" height="90" className="h-16 w-auto mix-blend-multiply sm:h-20" />
  </Link>
);

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 border-b border-[#B9A9D8]/30 bg-[#FAF8F4]/90 backdrop-blur-md" data-testid="site-header">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-3 focus:rounded-full focus:bg-white focus:px-4 focus:py-2">
        Skip to content
      </a>
      <div className="wrap flex h-[92px] items-center justify-between gap-6 sm:h-[104px]">
        <Logo />
        <nav aria-label="Main" className="hidden items-center gap-7 lg:flex">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} className={navClass} data-testid={`nav-${n.to.slice(1)}`}>
              {n.label}
            </NavLink>
          ))}
          <Link to="/book" className="btn-primary !px-5 !py-2.5 text-sm" data-testid="header-book-consult-button">
            Book a free intro
          </Link>
        </nav>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button className="rounded-full p-2 text-[#22304A] lg:hidden" aria-label="Open menu" data-testid="mobile-menu-button">
              <Menu className="h-6 w-6" />
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="w-[300px] border-l-[#B9A9D8]/40 bg-[#FAF8F4]">
            <SheetTitle className="font-display text-2xl text-[#22304A]">Menu</SheetTitle>
            <nav aria-label="Mobile" className="mt-8 flex flex-col gap-5">
              {NAV.map((n) => (
                <NavLink key={n.to} to={n.to} onClick={() => setOpen(false)} className={navClass} data-testid={`mobile-nav-${n.to.slice(1)}`}>
                  <span className="font-display text-2xl">{n.label}</span>
                </NavLink>
              ))}
              <Link to="/book" onClick={() => setOpen(false)} className="btn-primary mt-4" data-testid="mobile-book-consult-button">
                Book a free intro
              </Link>
            </nav>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
};
